module.exports = __webpack_public_path__ + "img/bank-connection-success.9f903090.png";